export const modulesData = [
  {
    title: 'TOMO 1 — Diagnóstico del jugador explosivo',
    subtitle:
      'Cómo saber qué te está frenando antes de entrenar más fuerte (50 páginas)',
    content: [
      {
        page: 'Pág 1',
        title: 'Portada del Tomo 1',
        desc: 'Diagnóstico del Jugador Explosivo',
      },
      {
        page: 'Pág 2',
        title: 'Objetivo del tomo',
        desc: 'Qué vas a medir, por qué no alcanza con “entrenar más” y cómo detectar tu punto débil.',
      },
      {
        page: 'Pág 3',
        title: 'El error más común del futbolista amateur',
        desc: 'Entrenar ejercicios sueltos sin saber si el problema es fuerza, técnica, velocidad, movilidad o coordinación.',
      },
      {
        page: 'Pág 4',
        title: 'Qué significa ser explosivo en fútbol',
        desc: 'Diferencia entre correr rápido, reaccionar rápido, cambiar de ritmo y sostener intensidad.',
      },
      {
        page: 'Pág 5',
        title: 'Las 5 capacidades clave del jugador explosivo',
        desc: 'Aceleración, frenada, cambio de dirección, fuerza útil y potencia de pegada.',
      },
      {
        page: 'Pág 6',
        title: 'Por qué los primeros 5 metros deciden jugadas',
        desc: 'Arranques cortos, duelos, anticipos, desmarques y pelotas divididas.',
      },
      {
        page: 'Pág 7',
        title: 'Diferencia entre velocidad de gimnasio y velocidad de cancha',
        desc: 'Por qué tener piernas fuertes no siempre te hace más rápido jugando.',
      },
      {
        page: 'Pág 8',
        title: 'Test 1: Aceleración en 5 metros',
        desc: 'Cómo medir tu primer paso y salida inicial.',
      },
      {
        page: 'Pág 9',
        title: 'Test 2: Sprint de 10 metros',
        desc: 'Cómo evaluar arranque corto y velocidad útil para fútbol.',
      },
      {
        page: 'Pág 10',
        title: 'Test 3: Sprint de 20 metros',
        desc: 'Cuándo importa la velocidad larga y cómo medirla.',
      },
      {
        page: 'Pág 11',
        title: 'Test 4: Cambio de dirección 5-10-5',
        desc: 'Evaluación de frenada, giro y re-aceleración.',
      },
      {
        page: 'Pág 12',
        title: 'Test 5: Salto vertical',
        desc: 'Indicador de potencia de piernas.',
      },
      {
        page: 'Pág 13',
        title: 'Test 6: Salto horizontal',
        desc: 'Indicador de potencia aplicada al desplazamiento.',
      },
      {
        page: 'Pág 14',
        title: 'Test 7: Equilibrio unilateral',
        desc: 'Control de tobillo, rodilla y cadera en una pierna.',
      },
      {
        page: 'Pág 15',
        title: 'Test 8: Movilidad de tobillo',
        desc: 'Por qué el tobillo limita sprint, frenada y remate.',
      },
      {
        page: 'Pág 16',
        title: 'Test 9: Movilidad de cadera',
        desc: 'Relación entre cadera, zancada, giro y potencia de pegada.',
      },
      {
        page: 'Pág 17',
        title: 'Test 10: Core anti-rotación',
        desc: 'La base invisible del remate fuerte y los cambios de dirección.',
      },
      {
        page: 'Pág 18',
        title: 'Test 11: Técnica de carrera básica',
        desc: 'Errores de postura, braceo, apoyo y frecuencia.',
      },
      {
        page: 'Pág 19',
        title: 'Test 12: Técnica de remate',
        desc: 'Apoyo, cadera, tronco, pierna libre y terminación.',
      },
      {
        page: 'Pág 20',
        title: 'Cómo registrar tus resultados',
        desc: 'Tabla inicial para anotar tiempos, saltos y sensaciones.',
      },
      {
        page: 'Pág 21',
        title: 'Clasificación del jugador',
        desc: 'Perfil lento, fuerte pero pesado, técnico sin potencia, rápido sin control, completo.',
      },
      {
        page: 'Pág 22',
        title: 'Perfil 1: jugador lento de arranque',
        desc: 'Características, errores comunes y prioridad de entrenamiento.',
      },
      {
        page: 'Pág 23',
        title: 'Perfil 2: jugador fuerte pero poco ágil',
        desc: 'Por qué el gimnasio no se transfiere automáticamente a la cancha.',
      },
      {
        page: 'Pág 24',
        title: 'Perfil 3: jugador rápido pero descontrolado',
        desc: 'Corre mucho, pero frena mal y se pasa de largo.',
      },
      {
        page: 'Pág 25',
        title: 'Perfil 4: jugador con buena técnica pero poca potencia',
        desc: 'Sabe pegarle, pero la pelota no sale fuerte.',
      },
      {
        page: 'Pág 26',
        title: 'Perfil 5: jugador que se funde rápido',
        desc: 'Tiene buen inicio, pero cae físicamente en el segundo tiempo.',
      },
      {
        page: 'Pág 27',
        title: 'Mapa de debilidades por posición',
        desc: 'Qué suele necesitar un delantero, volante, defensor, lateral y arquero.',
      },
      {
        page: 'Pág 28',
        title: 'Delanteros: qué medir primero',
        desc: 'Aceleración, desmarque, primer paso y definición potente.',
      },
      {
        page: 'Pág 29',
        title: 'Volantes: qué medir primero',
        desc: 'Resistencia explosiva, reacción, giros y repetición de esfuerzos.',
      },
      {
        page: 'Pág 30',
        title: 'Defensores: qué medir primero',
        desc: 'Frenada, giro, velocidad hacia atrás, duelos físicos y reacción.',
      },
      {
        page: 'Pág 31',
        title: 'Laterales y extremos: qué medir primero',
        desc: 'Sprint repetido, ida y vuelta, aceleración y cambio de ritmo.',
      },
      {
        page: 'Pág 32',
        title: 'Fútbol 5: necesidades físicas específicas',
        desc: 'Espacios cortos, reacción constante y cambios de dirección explosivos.',
      },
      {
        page: 'Pág 33',
        title: 'Fútbol 7: necesidades físicas específicas',
        desc: 'Más transiciones, más duelos y más carreras intermedias.',
      },
      {
        page: 'Pág 34',
        title: 'Fútbol 11: necesidades físicas específicas',
        desc: 'Sprints largos, cambios de ritmo y sostener intensidad.',
      },
      {
        page: 'Pág 35',
        title: 'Cómo saber si tu problema es fuerza',
        desc: 'Señales de falta de fuerza útil para fútbol.',
      },
      {
        page: 'Pág 36',
        title: 'Cómo saber si tu problema es técnica',
        desc: 'Señales de mala mecánica de carrera o remate.',
      },
      {
        page: 'Pág 37',
        title: 'Cómo saber si tu problema es movilidad',
        desc: 'Limitaciones que te hacen lento, rígido o inestable.',
      },
      {
        page: 'Pág 38',
        title: 'Cómo saber si tu problema es coordinación',
        desc: 'Cuando el cuerpo no acompaña la decisión.',
      },
      {
        page: 'Pág 39',
        title: 'Cómo saber si tu problema es resistencia explosiva',
        desc: 'Cuando empezás bien y terminás apagado.',
      },
      {
        page: 'Pág 40',
        title: 'Tabla de autoevaluación inicial',
        desc: 'Puntaje por capacidad física y futbolística.',
      },
      {
        page: 'Pág 41',
        title: 'Cómo elegir tu prioridad de entrenamiento',
        desc: 'Qué trabajar primero según tu resultado.',
      },
      {
        page: 'Pág 42',
        title: 'Errores que arruinan el progreso',
        desc: 'Entrenar cansado, copiar rutinas, no medir, no descansar, hacer demasiado volumen.',
      },
      {
        page: 'Pág 43',
        title: 'Cuántos días entrenar según tu nivel',
        desc: 'Principiante, intermedio y competitivo.',
      },
      {
        page: 'Pág 44',
        title: 'Cómo combinar este sistema con fútbol semanal',
        desc: 'Partidos, entrenamientos de club, gimnasio y recuperación.',
      },
      {
        page: 'Pág 45',
        title: 'Cómo medir progreso sin obsesionarse',
        desc: 'Cuándo volver a testear y qué resultados esperar.',
      },
      {
        page: 'Pág 46',
        title: 'Señales de alerta',
        desc: 'Dolor, fatiga excesiva, pérdida de rendimiento y riesgo de lesión.',
      },
      {
        page: 'Pág 47',
        title: 'Checklist del jugador explosivo',
        desc: 'Lista de control antes de empezar el plan.',
      },
      {
        page: 'Pág 48',
        title: 'Tu punto de partida',
        desc: 'Plantilla para completar objetivos personales.',
      },
      {
        page: 'Pág 49',
        title: 'Resumen del tomo',
        desc: 'Qué descubriste y cómo usarlo en los próximos tomos.',
      },
      {
        page: 'Pág 50',
        title: 'Acción final',
        desc: 'Completá tus tests y elegí tu prioridad principal.',
      },
    ],
  },
  {
    title: 'TOMO 2 — Velocidad real para fútbol',
    subtitle:
      'Primeros metros, reacción, aceleración y cambio de ritmo (50 páginas)',
    content: [
      {
        page: 'Pág 1-5',
        title: 'Fundamentos de la velocidad',
        desc: 'Por qué la velocidad en fútbol no es correr 100 metros. Los primeros 5 metros. Aceleración vs velocidad máxima.',
      },
      {
        page: 'Pág 6-10',
        title: 'Técnica y reacción',
        desc: 'Reacción visual y auditiva. Técnica básica de salida. Errores comunes: salir parado, pasos largos, brazos muertos.',
      },
      {
        page: 'Pág 11-20',
        title: 'Ejercicios de aceleración',
        desc: '10 ejercicios prácticos desde salidas laterales hasta persecución corta y escapada del defensor.',
      },
      {
        page: 'Pág 21-26',
        title: 'Cambio de ritmo',
        desc: 'Ritmo bajo, explosión y pausa. Ejercicios integrados con pelota, control y pase.',
      },
      {
        page: 'Pág 27-33',
        title: 'Frenar para volver a acelerar',
        desc: 'Mecánica de frenada. Ejercicios de sprint, freno y cambio lateral.',
      },
      {
        page: 'Pág 34-40',
        title: 'Cambio de dirección',
        desc: 'Ángulos de corte (45°, 90°, 180°). Ejercicios de zigzag y espejo con compañero.',
      },
      {
        page: 'Pág 41-44',
        title: 'Velocidad con pelota',
        desc: 'Conducción explosiva, freno y salida, cambio de dirección con control.',
      },
      {
        page: 'Pág 45-50',
        title: 'Rutinas y progresión',
        desc: 'Rutinas específicas para fútbol 5, 7 y 11. Cómo progresar semana a semana.',
      },
    ],
  },
  {
    title: 'TOMO 3 — Potencia de piernas y fuerza útil',
    subtitle: 'Cómo entrenar fuerza que se note en la cancha (50 páginas)',
    content: [
      {
        page: 'Pág 1-7',
        title: 'Fuerza útil para fútbol',
        desc: 'El error de entrenar como culturista. Tren inferior completo y core como transmisor de potencia.',
      },
      {
        page: 'Pág 8-15',
        title: 'Ejercicios base de fuerza',
        desc: 'Sentadillas, zancadas, step-up, peso muerto rumano, hip thrust.',
      },
      {
        page: 'Pág 16-23',
        title: 'Estabilidad y core',
        desc: 'Gemelos, aductores, planchas, dead bug, pallof press.',
      },
      {
        page: 'Pág 24-34',
        title: 'Pliometría y potencia',
        desc: 'Saltos verticales, horizontales, laterales, a una pierna. Skipping potente y bounds.',
      },
      {
        page: 'Pág 35-38',
        title: 'Transferencia y métodos',
        desc: 'Fuerza + aceleración. Métodos de contraste. Entrenamiento con y sin gimnasio.',
      },
      {
        page: 'Pág 39-42',
        title: 'Fuerza por posición',
        desc: 'Adaptaciones para delanteros, volantes, defensores y laterales.',
      },
      {
        page: 'Pág 43-50',
        title: 'Rutinas y progresión',
        desc: 'Niveles principiante, intermedio y competitivo. Cómo evitar sobrecarga y progresar cargas.',
      },
    ],
  },
  {
    title: 'TOMO 4 — Pegada potente y remate real de partido',
    subtitle: 'Cómo pegarle más fuerte sin perder técnica (50 páginas)',
    content: [
      {
        page: 'Pág 1-5',
        title: 'La cadena de potencia',
        desc: 'De dónde sale la potencia del remate. Suelo, apoyo, cadera, core, pierna y terminación.',
      },
      {
        page: 'Pág 6-10',
        title: 'Errores comunes',
        desc: 'Mal pie de apoyo, patear solo con la pierna, cuerpo atrás, tobillo flojo, no terminar el gesto.',
      },
      {
        page: 'Pág 11-15',
        title: 'Técnica detallada',
        desc: 'Pie de apoyo, cadera, tronco, tobillo y terminación.',
      },
      {
        page: 'Pág 16-23',
        title: 'Tipos de remate',
        desc: 'Empeine, cruzado, primer palo, colocado, de primera, en movimiento, bajo fatiga.',
      },
      {
        page: 'Pág 24-35',
        title: 'Ejercicios técnicos',
        desc: 'Desde apoyo sin pelota hasta remate bajo fatiga controlada.',
      },
      {
        page: 'Pág 36-43',
        title: 'Fuerza específica para remate',
        desc: 'Rotaciones, lanzamientos, aductores, core anti-rotación, movilidad.',
      },
      {
        page: 'Pág 44-50',
        title: 'Rutinas y medición',
        desc: 'Rutina técnica, física e integrada. Cómo medir la mejora y errores a evitar.',
      },
    ],
  },
  {
    title: 'TOMO 5 — Plan completo de 12 semanas',
    subtitle:
      'Cómo unir velocidad, fuerza, pegada y prevención en un sistema real (50 páginas)',
    content: [
      {
        page: 'Pág 1-9',
        title: 'Estructura del programa',
        desc: 'Fases, calendario general, niveles y cómo combinarlo con partido semanal.',
      },
      {
        page: 'Pág 10-13',
        title: 'Calentamientos',
        desc: 'Base, para velocidad, para fuerza y para pegada.',
      },
      {
        page: 'Pág 14-19',
        title: 'Fase 1: Semanas 1 a 4',
        desc: 'Base técnica, control corporal y fuerza inicial. Moverte mejor antes de moverte más fuerte.',
      },
      {
        page: 'Pág 20-25',
        title: 'Fase 2: Semanas 5 a 8',
        desc: 'Potencia, aceleración y remate más explosivo. Que la fuerza empiece a aparecer.',
      },
      {
        page: 'Pág 26-31',
        title: 'Fase 3: Semanas 9 a 12',
        desc: 'Transferencia real a partido. Jugar más rápido, más fuerte y con mejor control.',
      },
      {
        page: 'Pág 32-38',
        title: 'Adaptaciones específicas',
        desc: 'Planes para fútbol 5, 7, 11. Adaptaciones por posición.',
      },
      {
        page: 'Pág 39-50',
        title: 'Ajustes y recuperación',
        desc: 'Planes con/sin gimnasio, poco tiempo, prevención de lesiones, test final y mantenimiento.',
      },
    ],
  },
]

export const bonusesData = [
  {
    title: 'BONO 1 — Tests de velocidad, potencia y pegada',
    subtitle: 'Plantillas para medir tu progreso (25-30 páginas)',
    content: [
      {
        page: 'Pág 1-15',
        title: 'Batería de tests',
        desc: 'Sprints (5, 10, 20m), cambio de dirección, saltos, equilibrio, movilidad, core y remate.',
      },
      {
        page: 'Pág 16-19',
        title: 'Tablas de resultados',
        desc: 'Plantillas para inicio, semana 4, semana 8 y semana 12.',
      },
      {
        page: 'Pág 20-25',
        title: 'Interpretación y ajustes',
        desc: 'Qué hacer si no mejoraste velocidad, pegada o seguís fatigado. Perfil final.',
      },
    ],
  },
  {
    title: 'BONO 2 — Rutinas express de 20 minutos',
    subtitle: 'Para entrenar aunque tengas poco tiempo (25-30 páginas)',
    content: [
      {
        page: 'Pág 1-10',
        title: 'Rutinas de velocidad y fuerza',
        desc: 'Aceleración, reacción, cambio de dirección, fuerza sin gimnasio, potencia.',
      },
      {
        page: 'Pág 11-17',
        title: 'Rutinas específicas',
        desc: 'Pegada, core, tobillo, cadera, prevención y activación pre/post partido.',
      },
      {
        page: 'Pág 18-25',
        title: 'Rutinas por formato y posición',
        desc: 'Fútbol 5, 7, 11. Delantero, volante, defensor. Cómo combinarlas.',
      },
    ],
  },
  {
    title: 'BONO 3 — Plan anti-lesiones para futbolistas',
    subtitle: 'Isquios, aductores, rodilla, tobillo y cadera (25-30 páginas)',
    content: [
      {
        page: 'Pág 1-6',
        title: 'Fundamentos preventivos',
        desc: 'Por qué se lesiona el amateur. Lesiones frecuentes y calentamiento preventivo.',
      },
      {
        page: 'Pág 7-17',
        title: 'Zonas críticas',
        desc: 'Función y ejercicios para isquios, aductores, rodilla, tobillo, cadera y core.',
      },
      {
        page: 'Pág 18-25',
        title: 'Rutinas preventivas',
        desc: '10 min, 20 min, post-partido. Cómo volver tras molestia y semana modelo.',
      },
    ],
  },
  {
    title: 'BONO 4 — Plan por posición',
    subtitle:
      'Delanteros, volantes, defensores, laterales y extremos (25-30 páginas)',
    content: [
      {
        page: 'Pág 1-7',
        title: 'Delanteros',
        desc: 'Necesidades, rutinas de velocidad, remate y física.',
      },
      {
        page: 'Pág 8-15',
        title: 'Volantes y Defensores',
        desc: 'Reacción, repetición, giro, frenada, duelos y velocidad defensiva.',
      },
      {
        page: 'Pág 16-24',
        title: 'Laterales, Extremos y Arqueros',
        desc: 'Ida y vuelta, mano a mano, reacción, saltos y desplazamientos.',
      },
      {
        page: 'Pág 25-28',
        title: 'Planes mixtos',
        desc: 'Para jugadores polifuncionales y plan de 4 semanas por posición.',
      },
    ],
  },
  {
    title: 'BONO 5 — Planillas de seguimiento y calendario',
    subtitle: 'Organización completa del progreso (25-30 páginas)',
    content: [
      {
        page: 'Pág 1-6',
        title: 'Planillas iniciales',
        desc: 'Datos, tests y objetivos.',
      },
      {
        page: 'Pág 7-19',
        title: 'Calendarios semanales',
        desc: 'Vista general y planillas imprimibles de la semana 1 a la 12.',
      },
      {
        page: 'Pág 20-30',
        title: 'Registros específicos',
        desc: 'Partidos, velocidad, fuerza, pegada, fatiga, prevención y evaluación final.',
      },
    ],
  },
]
